import { useState, useEffect } from "react";
import { Grid, Dialog, Box, Divider, Badge } from "@mui/material";
import { loginState, configState } from "../lib/State";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import axios from "axios";
import MemberLevel from "./HomeMemberLevel";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Notification from "./Notification";
import { ReactComponent as NotificationIcon } from '../assets/notification.svg'
import send_webview_data from "../lib/send_webview_data";

const badgeTheme = createTheme({
  components: {
    MuiBadge: {
      styleOverrides: {
        standard: {
          background: "#00b375",
        },
        root: {
          // background: "black",
          borderRadius: 50,
          justifyContent: "center",
          alignItems: "center",
          width: 30,
          height: 30,
        },
      },
    },
  },
});

function HomeNotice(props) {
  let { p_count } = props;
  const { login } = props;
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(null);

  const openClick = () => {
    setOpen(true);
    send_webview_data({id:'unread_count', value:'reset'});
  };
  const closeClick = () => {
    setOpen(false);
    setCount(null);
  };

  useEffect(() => {
    if(p_count>0) {
      setCount(p_count);
    }
  }, [p_count]);

  return (
    <>
      <Dialog fullScreen open={open} onClose={closeClick}>
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={closeClick} />
          <Box
            sx={{
              margin: "25px 0 0 10px",
              fontSize: "22px",
            }}
          >
            알림
          </Box>
        </Box>
        <Divider />
        <Notification login={login}></Notification>
      </Dialog>

      <Box sx={{ position: "absolute", zIndex: 200, right: 13, top: 10 }}>
        <ThemeProvider theme={badgeTheme}>
          <Badge badgeContent={count} onClick={openClick}>
            <NotificationsIcon sx={{ color: "white", fontSize: "24px" }} />
          </Badge>
        </ThemeProvider>
      </Box>
    </>
  );
}

export default HomeNotice;
